import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { flatMap } from 'rxjs/operators';
import { UtilityService } from 'services';

@Injectable({
  providedIn: 'root'
})
export class AdminPreloaderService implements PreloadingStrategy {
  role: string;
  constructor(private util: UtilityService) {
    this.role = this.util.getUserRole();
  }
  preload(route: Route, load: Function): Observable<any> {
    if (this.role === 'OFFICIAL') {
      const loadRoute = delay =>
        delay ? timer(delay).pipe(flatMap(_ => load())) : load();
      return route.data && route.data.preload
        ? loadRoute(route.data.delay)
        : of(null);
    }
    return of(null);
  }
}
